import api from "@/api/visary-api";
import RemoteCrudService from "./remote-crud-service";

export default class AccountCrudService extends RemoteCrudService {
  constructor() {
    super("Account");
  }
  async save(patch) {
    return await api.user.createAccount(patch)
  }
}
